var _style, _path, _g, _path2, _g2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuristAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 40,
    viewBox: "0 0 178 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes float {\n  0% { transform: translateY(0px); }\n  50% { transform: translateY(-5px); }\n  100% { transform: translateY(0px); }\n}\n\n.floating-tile {\n  animation: float 3s ease-in-out infinite;\n  transform-box: fill-box;\n  transform-origin: center;\n}\n")), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 32,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49057 36.4865H22.6864C23.2223 36.4883 23.7495 36.4269 24.2682 36.3024C24.7869 36.177 25.2808 35.9929 25.7499 35.7484C26.219 35.5039 26.648 35.208 27.0371 34.8597C27.4261 34.5115 27.7626 34.1226 28.0468 33.6941L38.6321 17.4701C39.6275 15.9435 38.4337 14.0001 36.5001 14.0001H23.2156C22.6931 13.9974 22.1792 14.0578 21.6729 14.1796C21.1676 14.3014 20.6861 14.4819 20.2284 14.7201C19.7708 14.9583 19.3522 15.247 18.9727 15.5862C18.5932 15.9255 18.2652 16.3044 17.9878 16.723L7.35864 33.021C6.36323 34.5422 7.55791 36.4865 9.49057 36.4865Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99951 13.9974V36.4883H39.0357V13.9974H6.99951Z",
    fill: "#284838"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_622_855",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 33,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08285 25.3735H20.2787C20.8146 25.3753 21.3418 25.3139 21.8605 25.1894C22.3792 25.064 22.8731 24.8799 23.3422 24.6354C23.8113 24.3909 24.2403 24.095 24.6293 23.7467C25.0183 23.3985 25.3549 23.0096 25.639 22.581L36.2243 6.35707C37.2197 4.83049 36.026 2.88708 34.0924 2.88708H20.8079C20.2854 2.88437 19.7715 2.94482 19.2652 3.06663C18.7599 3.18843 18.2784 3.36887 17.8207 3.60706C17.363 3.84525 16.9445 4.13397 16.565 4.47321C16.1855 4.81245 15.8575 5.19139 15.5801 5.61002L4.95092 21.908C3.95551 23.4291 5.15019 25.3735 7.08285 25.3735Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_622_855)",
    className: "floating-tile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5918 2.88437V25.3753H36.628V2.88437H4.5918Z",
    fill: "#042916"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 28,
    fill: "#042916",
    fontFamily: "'IvyPresto Headline', 'EB Garamond', Georgia, serif",
    fontSize: 26,
    letterSpacing: -0.4
  }, "Nougat")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuristAi);
export default __webpack_public_path__ + "static/media/JuristAI.fb5ed97545d0fa043f821d136f157d81.svg";
export { ForwardRef as ReactComponent };